import React from "react";
import { ChecklistCompactDisplay } from "../ChecklistCompactDisplay";
import { ChecklistDetailsDisplay } from "../ChecklistDetailsDisplay";
import { ChecklistValue } from "../checklistTypes";
import { FieldDisplayRendererProps } from "./types";

export const ChecklistDisplayRenderer = ({
  field,
  value,
  onChange,
  t,
  theme,
}: FieldDisplayRendererProps) => {
  if (!value || !Array.isArray(value) || value.length === 0) {
    return null;
  }

  const checklistValue = value as ChecklistValue[];

  if (!onChange) {
    return (
      <ChecklistCompactDisplay value={checklistValue} label={t(field.label)} />
    );
  }

  const handleToggleItem = (checklistId: string, itemId: string) => {
    const updatedChecklists = checklistValue.map((checklist) =>
      checklist.id === checklistId
        ? {
            ...checklist,
            items: checklist.items.map((item) =>
              item.id === itemId ? { ...item, checked: !item.checked } : item,
            ),
          }
        : checklist,
    );

    onChange(field.name, updatedChecklists);
  };

  return (
    <ChecklistDetailsDisplay
      value={checklistValue}
      label={t(field.label)}
      outlineColor={theme.colors.outline}
      onToggleItem={handleToggleItem}
    />
  );
};
